import {
  CLEAR_CU_NOTIFICATIONS,
  GET_CU_NOTIFICATIONS_SUCCESS,
} from '../actionConstants';

const defaultState = {};

export default (state = defaultState, action) => {
  const { type, res, isClearPrevious } = action;
  switch (type) {
    case GET_CU_NOTIFICATIONS_SUCCESS:
      if (isClearPrevious) return res.data || {};
      return { ...res.data, results: [...state.results, ...res.data.results] };
    case CLEAR_CU_NOTIFICATIONS:
      return defaultState;
    default:
      return state;
  }
};
